import React from 'react';
import PropTypes from 'prop-types';

import ProductPropertyTab, { PropertyList } from '../../molecules/product-detail-accordion';

const KeyIngredientsBenefits = (props) => {
  if (!props.product) return null;

  let ingredients = props.product?.product_properties?.filter(
    (property) => property.property_name === 'Key Ingredients & Benefits'
  );

  if (!ingredients || ingredients.length === 0) return null;

  ingredients = ingredients.reduce((acc, curr) => {
    const { value } = curr;

    try {
      // no validation that there isn't more than one colon
      const [key, ...rest] = value.split(':');
      acc.push([key, rest.join().trim()]);
    } catch (error) {
      acc.push([false, value]);
    }

    return acc;
  }, []);

  return (
    <ProductPropertyTab title="Key Ingredients & Benefits">
      <PropertyList element="ul" like="paragraph-2">
        {
          ingredients.map(([key, value]) => (
            <li key={key || value}>
              {
                key
                  ? <b>{`${key}: `}</b>
                  : ''
              }
              {value}
            </li>
          ))
        }
      </PropertyList>
    </ProductPropertyTab>
  );
};
KeyIngredientsBenefits.propTypes = {
  product: PropTypes.object.isRequired
};

export default KeyIngredientsBenefits;
